/**
 * @file 防抖指令
 */
export default {
    bind(el, binding) {
        // Default configuration
        const defaultConfig = {
            handler: null,
            event: 'input',
            delay: 500,
            immediate: false
        }

        // Parse binding value
        let config = {}

        if (typeof binding.value === 'function') {
            config.handler = binding.value
        } else if (Array.isArray(binding.value)) {
            const [handler, event, delay] = binding.value
            config = {
                handler,
                event: event || defaultConfig.event,
                delay: delay || defaultConfig.delay
            }
        } else if (typeof binding.value === 'object') {
            config = { ...binding.value }
        } else {
            console.error('[v-debounce] Invalid binding value')
            return
        }

        // Merge with default config
        config = { ...defaultConfig, ...config }

        // Validate handler
        if (typeof config.handler !== 'function') {
            console.error('[v-debounce] Handler must be a function')
            return
        }

        // Store config on element
        el._debounceConfig = config
        el._debounceTimer = null

        // Create debounced handler
        const debouncedHandler = (...args) => {
            if (el._debounceTimer) {
                clearTimeout(el._debounceTimer)
            }

            if (config.immediate && !el._debounceTimer) {
                try {
                    config.handler.apply(this, args)
                } catch (err) {
                    console.error('[v-debounce] Error in handler:', err)
                }
            }

            el._debounceTimer = setTimeout(() => {
                try {
                    if (!config.immediate) {
                        config.handler.apply(this, args)
                    }
                    el._debounceTimer = null
                } catch (err) {
                    console.error('[v-debounce] Error in handler:', err)
                    el._debounceTimer = null
                }
            }, config.delay)
        }

        // Store handler reference for unbind
        el._debouncedHandler = debouncedHandler

        // Add event listener
        el.addEventListener(config.event, debouncedHandler, { passive: true })
    },

    unbind(el) {
        // Clean up
        if (el._debounceTimer) {
            clearTimeout(el._debounceTimer)
        }

        if (el._debouncedHandler && el._debounceConfig) {
            el.removeEventListener(el._debounceConfig.event, el._debouncedHandler)
        }

        // Remove references
        delete el._debounceTimer
        delete el._debouncedHandler
        delete el._debounceConfig
    }
}

